import React, { Component } from "react";
import {  Row, Col, Button, ListGroup, Form, Alert , Modal } from "react-bootstrap";

//import { LinkContainer } from "react-router-bootstrap";
import "containers/common/List.css";
import ReactTable from "react-table";


import Moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import Creatable from 'react-select/creatable';

export default class PropertyIntegrationsList extends Component {
    constructor(props) {
        super(props);

        console.log('this props data:', this.props.data);

        this.state = {
            searching: false,
            isLoading: true,
            filter: {},
            dataSet: "integrations",
            dataRecord: (['slmsale', 'slmlease'].includes(props.ctx)) ? "slmPropertyIntegrations" : "propertyIntegrations",
            dataSetPrimaryKey: "property_integration_id",
            showAlert: false,
            errorMessage: "",
            savingNewRecord: false,
            ctx: this.props.ctx
        };

        this.acceptIntegration = this.props.acceptIntegration;
        this.rejectIntegration = this.props.rejectIntegration;
    }
    

    async componentDidMount() {
        this.setState({ isLoading: true });     
        if (!this.props.isAuthenticated) { // if false
            return;
        }                        

        this.setState({ isLoading: false });      
    }

    handleDeleteRecord = async (cellInfo, event) => {
        event.preventDefault();        

        let data = [...this.props.data];
        var r = window.confirm("Are you sure you want to delete this record?");

        if (r === true) {
            console.log(cellInfo);

            data[cellInfo.index].archived_date = new Date();

            await this.handleDataSave(data[cellInfo.index]).then((result) => {
                data.splice(cellInfo.index, 1);
                this.props.updateTableState(data, this.state.dataSet);
            });
        };
    };

    async handleDataSave(data) {
        try {
            return await this.props.saveRecord(data, this.state.dataRecord, this.state.dataSetPrimaryKey);



        } catch (e) {
            alert("Error saving");
        }
    }
    
    handleSave = async (cellInfo, event) => {

        this.setState({ showAlert: false });
        let data = [...this.props.data];
        for (var i=0; i<data.length; i++){
            const validation = this.props.validateRelatedRecord(data[i], this.state.dataSet);
            console.log(validation[0]);
            if (data[i].hasOwnProperty("modified")) {
                if (data[i].modified === true) {

                    if (validation[0] === true) {
                
                        console.log(i);
                        //Save the data
                        if (!this.state.savingNewRecord) {
                            if (data[i].hasOwnProperty("new_record")) {
                                if (data[i].new_record === true) {
                                    this.setState({ savingNewRecord: true });
                                }
                            }
                            const result = await this.handleDataSave(data[i]);
                            if (result.result) {
                                data[i].modified = false;
                                if (data[i].hasOwnProperty("new_record")) {
                                    if (data[i].new_record === true) {

                                        data[i][this.state.dataSetPrimaryKey] = result.id;
                                        this.setState({ savingNewRecord: false });
                                    }
                                    data[i].new_record = false;
                                }
                                                               
                            }
                            else {
                                this.setState({ errorMessage: result.error_message });
                                this.setState({ showAlert: true });
                                return;
                            }
                        }
                   
            } //validate
            else {
                this.setState({ errorMessage: validation[1] });
                this.setState({ showAlert: true,  });
            }

            }

        }
        }   //for loop   
        this.props.updateTableState(data, this.state.dataSet);


    }

    renderTable(data) {
        const getAcceptRejectButton = row => {
            if (row.original.is_accepted == null) {
                return (<Button type="button" size="sm" variant="secondary" onClick={(e) => this.acceptIntegration(row,e)}>Pending</Button>);
            } else if (row.original.is_accepted == true && row.original.accept_reject_by != 'system') {
                return (<Button type="button" size="sm" variant="success" onClick={(e) => this.rejectIntegration(row,e)}>Accepted</Button>);
            } else if (row.original.is_accepted == true && row.original.accept_reject_by == 'system') {
                return (<Button type="button" size="sm" variant="success" onClick={(e) => this.rejectIntegration(row,e)}>Auto-Accepted</Button>);
            } else if (row.original.is_accepted == false) {
                return (<Button type="button" size="sm" variant="danger" onClick={(e) => this.acceptIntegration(row,e)}>Rejected</Button>);
            }
        };

        const columns = [

            {
                id: 'property_integration_id',
                Header: 'ID',
                maxWidth: 65,
                accessor: 'property_integration_id'
            },
            {
                id: 'value_to_match',
                Header: 'CoLin Address',
                accessor: 'value_to_match',
                style: { 'white-space': 'unset' } ,
            },
             
            {
                id: 'integration_property_id',
                Header: 'CoreLogic Property ID',
                accessor: 'integration_property_id',
                maxWidth: 100,

            },
            {
                id: 'integration_address',
                Header: 'CoreLogic Address',
                accessor: 'integration_address',
                Cell: row => (<a href={'https://rpp.corelogic.com.au/property/' + row.original.integration_property_id} target="_blank">{row.original.integration_address}</a>),
                style: { 'white-space': 'unset' } ,
            },
            {
                id: 'integration_parcel_identifier',
                Header: 'Parcel',
                accessor: 'integration_parcel_identifier',
                maxWidth: 65,

            },
            {
                id: 'match_method',
                Header: 'Matched By',
                accessor: 'match_method',
                maxWidth: 65,

            },
            {
                id: 'parse_status',
                Header: 'Parsing Status',
                accessor: 'parse_status',
                maxWidth: 65,

            },
            {
                id: 'match_type',
                Header: 'Match Type',
                accessor: 'match_type',
                maxWidth: 65
            },
            {
                id: 'match_rule',
                Header: 'Match Rule',
                accessor: 'match_rule',
                maxWidth: 65
            },
            {
                id: 'created_date',
                Header: 'Date Created',
                accessor: d => {
                    if (d.created_date) {
                        return Moment(d.created_date)
                            .local()
                            .format("DD-MM-YYYY")
                    }
                    else { return null }
                },
                maxWidth: 80

            },
            {
                id: 'last_edited_date',
                Header: 'Last Edited',
                accessor: d => {
                    if (d.last_edited_date) {
                        return Moment(d.last_edited_date)
                            .local()
                            .format("DD-MM-YYYY")
                    }
                    else { return null }
                },
                maxWidth: 80
            },
            {
                id: 'last_edited_by',
                Header: 'Edited By',
                accessor: 'last_edited_by',
                maxWidth: 100,
            },
            {
                Header: '',
                accessor: 'id',
                maxWidth: 120,
                Cell: row => getAcceptRejectButton(row)
            },
            {
                Header: '',
                accessor: 'property_integration_id',
                maxWidth: 65,
                Cell: row => <Button type="button" size="sm" variant="danger" onClick={(e) => this.handleDeleteRecord(row,e)}>Delete</Button>
            }
        ]

        if (!data) {
            return null
        }
        else {
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={10}
                    sortable={false}
                />
            )
        }

    }

    //Modify the attribute shown in the list for each type of record
    renderList(data) {
        const getStatusString = integration => {
            if (integration.is_accepted == null) return 'pending';
            if (integration.is_accepted === true && integration.accept_reject_by !== 'system') return 'accepted';
            if (integration.is_accepted === true && integration.accept_reject_by === 'system') return 'auto-accepted';
            if (integration.is_accepted === false) return 'rejected';
        }

        if (!data) {
            return null
        }
        else {
            return [{}].concat(data).map(
                (d, i) =>
                    i !== 0
                        ?
                        <ListGroup.Item key={i} as="a" header={d}>
                           <a href={'https://rpp.corelogic.com.au/property/' + d.integration_property_id} target="_blank">{ d.integration_property_id}: { d.integration_address }</a>  ({getStatusString(d)})
                        </ListGroup.Item>
                        : ""
            );
        }
    }

 

    renderComponent() {
        return (
            <div className="addresses">
                <Row className="show-Container">
                    <Col sm={12} md={12} lg={12}>
                    { !this.state.isLoading && this.props.controlType === "table" ? this.renderTable(this.props.data) : this.renderList(this.props.data) }
                    </Col>
                </Row>
            </div>
        );
    }
    render() {
        if (!this.props.data) {
            return null
        }
        else {
            return (

                <div className="AddressSection">
                    {this.props.isAuthenticated ? this.renderComponent() : console.log("error)")}
                </div>
            );
        }
  }
}
